import { MockCard, MockInput, MockSelect } from '../../components/mockups/MockUI'
import { MockStatusBadge } from '../../components/mockups/MockBadge'
import { MockTable } from '../../components/mockups/MockTable'

export function ProcRequestsList() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Заявки (для закупщика)
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Закупщик видит все заявки, в которых есть позиции с матрицей «Китай» или «Производители».
          Вместо имени клиента отображается код клиента (конфиденциальность).
        </p>
      </div>
      <MockTable
        caption="Отличия от таблицы менеджера"
        columns={[{ header: 'Элемент' }, { header: 'Менеджер' }, { header: 'Закупщик' }]}
        rows={[
          ['Клиент', 'ООО «Электросервис»', 'Э001 (только код)'],
          ['Квоты', 'Сумма КП', 'Мои квоты: 3/8'],
          ['Колонки', 'Все', 'Без имени клиента'],
          ['Фильтр', 'Все статусы', '+ кнопка «Обработанные»'],
        ]}
      />
    </div>
  )
}

export function ProcRequestsDetail() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Страница заявки (закупщик)
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Закупщик видит заявку по-другому: вместо имени клиента — код, столбец КП показывает число
          квот, а рядом с артикулом — зелёная галочка если вы уже дали квоту по этой позиции.
        </p>
      </div>
      <MockCard>
        <div className="flex items-center gap-3 mb-3">
          <span className="text-xs text-gray-500 dark:text-gray-400">Заявки ›</span>
          <span className="font-mono font-medium text-gray-900 dark:text-gray-100">Э001</span>
          <span className="text-gray-400">—</span>
          <span className="font-medium text-gray-900 dark:text-gray-100">17.04.26-3</span>
          <MockStatusBadge status="IN_PROGRESS" />
        </div>
        <div className="text-xs text-gray-500 dark:text-gray-400">
          ↑ Breadcrumb: код клиента — номер заявки (без названия клиента)
        </div>
      </MockCard>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Специальные элементы:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>
              <span className="text-green-600">✓</span> после артикула — вы уже дали квоту по этой
              позиции
            </li>
            <li>Столбец «КП»: число (например «2») вместо бейджей с именами закупщиков</li>
            <li>Кнопки «Скачать запрос» и «Загрузить ответ» — для Excel-workflow</li>
          </ul>
        </div>
      </MockCard>
    </div>
  )
}

export function ProcRequestsNotes() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Заметки закупщика
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          В таблице (страница «Таблица») у каждого закупщика есть персональная колонка для заметок.
          Заметки видны только вам и ADMIN'у.
        </p>
      </div>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Как использовать:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>Кликните на ячейку в вашей колонке — откроется редактор</li>
            <li>Напишите заметку (например, «запрос отправлен Chipsmall 17.04»)</li>
            <li>Заметка сохраняется автоматически при потере фокуса</li>
            <li>Другие закупщики НЕ видят ваши заметки (только ADMIN видит все)</li>
          </ul>
        </div>
      </MockCard>
    </div>
  )
}

export function ProcQuotesCreate() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Создание квоты
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Квота (котировка) — цена от поставщика на конкретную позицию. Создаётся двумя способами.
        </p>
      </div>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-3">
          <div className="font-medium text-gray-800 dark:text-gray-200">
            Способ 1: через форму на странице позиции
          </div>
          <div className="space-y-2 ml-4">
            <MockSelect label="Источник" value="Китай" />
            <MockInput label="Поставщик" value="Chipsmall" />
            <MockInput label="Цена" value="1.44" />
            <MockSelect label="Валюта" value="USD" />
            <MockInput label="Заметка" placeholder="Комментарий к цене..." />
          </div>
        </div>
      </MockCard>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">
            Способ 2: через Excel (массовый)
          </div>
          <ol className="list-decimal list-inside space-y-1">
            <li>Скачайте запрос из очереди закупки</li>
            <li>Отправьте поставщику — он заполнит цены</li>
            <li>Загрузите ответ — квоты создадутся автоматически для всех строк</li>
          </ol>
          <p className="mt-2">
            При создании квоты с реальной ценой позиция автоматически переходит в статус «Найден», а
            заявка — в «В работе» (если была «Новая»). Квоты с ценой 0 статусы не двигают и в КП не
            попадают.
          </p>
        </div>
      </MockCard>
    </div>
  )
}

export function ProcQuotesEdit() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Редактирование квоты
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Автор квоты или ADMIN может отредактировать ранее созданную квоту.
        </p>
      </div>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Как редактировать:</div>
          <ol className="list-decimal list-inside space-y-1">
            <li>Откройте страницу позиции (клик на партномер или стрелочку ↗)</li>
            <li>В разделе «Квоты» найдите нужную строку</li>
            <li>Нажмите иконку карандаша ✎ — откроется инлайн-форма</li>
            <li>Измените поля: поставщик, цена, валюта, матрица, заметка</li>
            <li>Нажмите «Сохранить» — коэффициент пересчитается автоматически</li>
          </ol>
          <p className="mt-2 text-amber-600 dark:text-amber-400">
            Вы можете редактировать только свои квоты. ADMIN может редактировать любые.
          </p>
        </div>
      </MockCard>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-1">
          <div className="font-medium text-gray-800 dark:text-gray-200">Удаление квоты:</div>
          <p>
            Рядом с квотой есть иконка корзины — удалить можно свою квоту (ADMIN — любую). После
            удаления статусы позиции и заявки пересчитываются автоматически. Квота с ценой 0
            («заготовка» или «Позиция отсутствует») в выбор лучшей цены и в КП всё равно не попадает
            — удалять её ради этого не нужно.
          </p>
        </div>
      </MockCard>
    </div>
  )
}
